// Pure string helpers for offline placeholder ids. No imports on purpose:
// node tests load this file directly (scripts/test-offline-temp-ids.mjs).
export const TEMP_PREFIX = 'temp_';

// Placeholder ids as generateTempId emits them: temp_<entityType>_<uuid v4>.
export const TEMP_ID_PATTERN = /temp_[A-Za-z]+_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g;

/** Unique placeholder ids found anywhere in a string (e.g. a JSON request body). */
export function findTempIds(text) {
  if (typeof text !== 'string' || !text.includes(TEMP_PREFIX)) return [];
  return Array.from(new Set(text.match(TEMP_ID_PATTERN) || []));
}

/** Replace every mapped placeholder in the text; unmapped ones are left in place. */
export function remapTempIds(text, mappings) {
  let resolved = text;
  for (const m of mappings || []) {
    if (m?.tempId && m?.serverId && resolved.includes(m.tempId)) {
      resolved = resolved.replaceAll(m.tempId, m.serverId);
    }
  }
  return resolved;
}

